import useOrganization from '../../hooks/use-organization';

import OrgLocationIndex from './organization/index';
import StationR from './station';

function LocationIndex() {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? <OrgLocationIndex /> : <StationR />;
}

export default LocationIndex;
